var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "sharo-modal-container": true, "active-modal": _vm.value } },
    [
      _c("div", { staticClass: "sharo-modal" }, [
        _c("div", { staticClass: "modal-top-info" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _c(
            "div",
            {
              staticClass: "close-modal icon-hoverable",
              on: { click: _vm.onClose }
            },
            [
              _c("font-awesome-icon", {
                staticClass: "icon-hoverable",
                staticStyle: {
                  "font-size": "23px",
                  color: "rgb(100, 100, 100)"
                },
                attrs: { icon: ["fas", "times"] }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }